// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all Partners
export const viewPartners = createAsyncThunk(
  "partners",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}backend-api/partners/data`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  },
);
